import { createZodDto } from 'nestjs-zod/dto';
import { z } from 'zod';
import { objectValidator } from '#validation';
import { userEmailValidator } from '#validation/user';
import { userIdentitySchema } from './identity';
import { PendingInvitationSchema } from './pending-invitation.schema';
export const userCreateSchema = z.object({
    email: userEmailValidator,
    firstName: z.string().optional(),
    lastName: z.string().optional(),
    pendingInvitation: PendingInvitationSchema.optional(),
    userIdentity: objectValidator({
        object: userIdentitySchema,
        requiredError: 'user.userIdentity.required',
    }),
});
export class UserCreateDto extends createZodDto(userCreateSchema) {
}
